import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';

type ExportData = any[] | Record<string, any[]>;

const isEmpty = (data: ExportData) => {
  if (Array.isArray(data)) return data.length === 0;
  return Object.values(data).every(arr => arr.length === 0);
};

export const exportToPDF = (data: ExportData, title: string) => {
  if (!data || isEmpty(data)) {
    alert('Não há dados para exportar.');
    return;
  }

  const doc = new jsPDF();
  
  if (Array.isArray(data)) {
    doc.text(title, 14, 15);
    const head = [Object.keys(data[0] || {})];
    const body = data.map(item => Object.values(item).map(val => val !== null && val !== undefined ? String(val) : ''));
    autoTable(doc, { head, body, startY: 20, theme: 'grid', styles: { fontSize: 8 }, headStyles: { fillColor: [30, 58, 138] } });
  } else {
    let first = true;
    for (const [key, val] of Object.entries(data)) {
      if (!val || val.length === 0) continue;
      if (!first) doc.addPage();
      first = false;
      doc.text(`${title} - ${key}`, 14, 15);
      const head = [Object.keys(val[0] || {})];
      const body = val.map(item => Object.values(item).map(v => v !== null && v !== undefined ? String(v) : ''));
      autoTable(doc, { head, body, startY: 20, theme: 'grid', styles: { fontSize: 8 }, headStyles: { fillColor: [30, 58, 138] } });
    }
  }

  doc.save(`${title.replace(/\s+/g, '_').toLowerCase()}.pdf`);
};

export const exportToXLSX = (data: ExportData, title: string) => {
  if (!data || isEmpty(data)) {
    alert('Não há dados para exportar.');
    return;
  }

  const workbook = XLSX.utils.book_new();
  
  if (Array.isArray(data)) {
    const worksheet = XLSX.utils.json_to_sheet(data);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório');
  } else {
    for (const [key, val] of Object.entries(data)) {
      if (!val || val.length === 0) continue;
      const worksheet = XLSX.utils.json_to_sheet(val);
      XLSX.utils.book_append_sheet(workbook, worksheet, key.substring(0, 31));
    }
  }
  
  XLSX.writeFile(workbook, `${title.replace(/\s+/g, '_').toLowerCase()}.xlsx`);
};

export const exportToCSV = (data: ExportData, title: string) => {
  if (!data || isEmpty(data)) {
    alert('Não há dados para exportar.');
    return;
  }

  let csv = '';
  if (Array.isArray(data)) {
    csv = Papa.unparse(data);
  } else {
    for (const [key, val] of Object.entries(data)) {
      if (!val || val.length === 0) continue;
      csv += `--- ${key} ---\n`;
      csv += Papa.unparse(val) + '\n\n';
    }
  }
  
  const blob = new Blob(["\uFEFF" + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${title.replace(/\s+/g, '_').toLowerCase()}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
